import { render } from "./Chapter.vue?vue&type=template&id=1c1007ae"
import script from "./Chapter.vue?vue&type=script&lang=js"
export * from "./Chapter.vue?vue&type=script&lang=js"

import "./Chapter.vue?vue&type=style&index=0&id=1c1007ae&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__